import React, { FC, useMemo } from 'react';
import styles from './index.module.scss';
import Avatar from 'src/common/Avatar';
import { IDocumentsTableProps } from '../../types';
import DocumentsNodeName from '../../DocumentsView/DocsName';
import dayjs from 'src/helpers/dayjs';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudDownload, faEdit, faTrash } from '@fortawesome/pro-light-svg-icons';
import { DocsNodeType } from 'src/models/documentsLibrary/types';
import classNames from 'classnames';
import { DELETED_USER } from 'src/models/users/types';

interface Props {
  docsNode: IDocumentsTableProps;
}

export const DocumentsDragPreview: FC<Props> = ({ docsNode }) => {
  const { createDateTime, nodeType, childNodes, createdBy } = docsNode;
  const { t } = useTranslation();

  const createdAt = useMemo(() => {
    const date = dayjs(createDateTime);
    return t('Common.Format.utcDateTimeFormat', { date: date.toDate() });
  }, [createDateTime, t]);

  return (
    <div className={styles.dragPreview}>
      <div className={styles.inner}>
        <div className={styles.colName}>
          <DocumentsNodeName docsNode={docsNode} eventSource="Document Library" />
        </div>
        <div className={styles.colCreatedAt}>{createdAt}</div>
        <div className={styles.colCreatedBy}>
          <Avatar user={createdBy ?? DELETED_USER} size={'s'} />
        </div>
        <div className={styles.colActions}>
          <ul className={styles.actions}>
            {nodeType === DocsNodeType.FILE && (
              <li className={styles.action}>
                <FontAwesomeIcon icon={faCloudDownload} className={styles.icon} />
              </li>
            )}
            <li className={styles.action}>
              <FontAwesomeIcon icon={faEdit} className={styles.icon} />
            </li>
            <li className={styles.action}>
              <FontAwesomeIcon
                icon={faTrash}
                className={classNames(styles.icon, { [styles.isDisabled]: !!childNodes?.length })}
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DocumentsDragPreview;
